import React, { useEffect, useState } from "react";
import { NOTIFICATION_INTERVAL, ACTIVITY_LEVEL, ALL_APPOINTMENT_STATUS, ALLERGIES, APPOINTMENT_STATUS, APPOINTMENT_ZONE, CRAVING_FOODS, CUISINE_PREFERENCE, decideStatus, DIET_TYPE, DRINKING_HABITS, HEALTH_FITNESS_GOALS, LOADER_TIMEOUT_TIME, MEAL_TIMES, MEDICAL_CONDITIONS, ROLE, SLEEP_QUALITY, SMOKING_HABITS, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter, extractTime, formateDate, getUser, handleOffcanvasScroll, handleServerValidations, TrimText, useDebouncing } from "../../../../utils/commonfunction";
import CustomError from "../../../../utils/customError";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import RecordNotFound from "../../shared/recordNotFound";
import { DatePicker, Drawer, SelectPicker, TagPicker } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";
import { addAppointments, dietChartAdd, dietChartDetails, dietChartGenerate, dietChartHistory, editAppointments, getAppointments, listAppointments } from "../../services/patient.services";
import { useValidationSchemas } from "../../../center/validator/validation";

export default function PatientDietChart() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { addDietChartValidationSchema } = useValidationSchemas();
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [searchParams] = useSearchParams();
    const patientData = searchParams?.get("patient_id");
    const [detailsData, setDetailsData] = useState({});
    const location = useLocation();
    const patientDetails = location?.state?.patientData
    console.log("patientDetails", patientDetails);

    useEffect(() => {
        const formData = new FormData()
        formData.append("patient_id", patientData)
        dietChartDetails(formData)
            .then((response) => {
                setDetailsData(response?.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const addForm = useFormik({
        initialValues: {
            medical_condition: detailsData?.medical_condition ?? [],
            other_medical_condition: detailsData?.other_medical_condition ?? "",
            allergies: detailsData?.allergies ?? [],
            other_allergies: detailsData?.other_allergies ?? "",
            meal_times: detailsData?.meal_times ?? [],
            activity_level: detailsData?.activity_level ?? "",
            sleep_quality: detailsData?.sleep_quality ?? "",
            drinking_habits: detailsData?.drinking_habits ?? "",
            smoking_habits: detailsData?.smoking_habits ?? "",
            diet_type: detailsData?.diet_type ?? "",
            cuisine_preference: detailsData?.cuisine_preference ?? [],
            carving_foods: detailsData?.carving_foods ?? [],
            health_fitness_goals: detailsData?.health_fitness_goals ?? [],
            wake_up_time: detailsData?.wake_up_time ?? "",
            sleep_time: detailsData?.sleep_time ?? "",
            bmi: detailsData?.bmi ?? "",
            bmr: detailsData?.bmr ?? "",
            age: patientDetails?.age ?? detailsData?.age ?? "",
            tdee: detailsData?.tdee ?? "",
        },
        validate: (values) => {
            const errors = {};
            if (values.medical_condition?.includes("other")) {
                if (!values.other_medical_condition) {
                    errors.other_medical_condition = "This field is required";
                }
            }
            if (values.allergies?.includes("other")) {
                if (!values.other_allergies) {
                    errors.other_allergies = "This field is required";
                }
            }
            return errors;
        },
        validationSchema: addDietChartValidationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            if (!patientDetails?.health_matrix || Object.keys(patientDetails.health_matrix).length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Missing Health Matrix',
                    text: 'Please update health matrix first.',
                });
                return;
            }
            const formData = new FormData();
            formData.append("patient_id", patientData);
            formData.append("medical_condition", JSON.stringify(values.medical_condition));
            formData.append("allergies", JSON.stringify(values.allergies));
            formData.append("meal_times", JSON.stringify(values.meal_times));
            formData.append("cuisine_preference", JSON.stringify(values.cuisine_preference));
            formData.append("carving_foods", JSON.stringify(values.carving_foods));
            formData.append("health_fitness_goals", JSON.stringify(values.health_fitness_goals));
            formData.append("activity_level", values.activity_level);
            formData.append("sleep_quality", values.sleep_quality);
            formData.append("drinking_habits", values.drinking_habits);
            formData.append("smoking_habits", values.smoking_habits);
            formData.append("diet_type", values.diet_type);
            formData.append("wake_up_time", values.wake_up_time);
            formData.append("sleep_time", values.sleep_time);
            formData.append("bmi", values.bmi);
            formData.append("bmr", values.bmr);
            formData.append("age", values.age);
            formData.append("other_medical_condition", values.other_medical_condition);
            formData.append("other_allergies", values.other_allergies);
            formData.append("tdee", values.tdee);
            setAddSubmissionLoader(true);
            dietChartAdd(formData)
                .then((response) => {
                    // setAddSubmissionLoader(false);
                    if (response.success) {
                        // Swal.fire({
                        //     icon: "success",
                        //     text: response.message,
                        //     ...SWAL_SETTINGS,
                        // });
                        // resetForm();
                        // setRefreshList(!refreshList);
                        const formData = new FormData();
                        // Append patient ID
                        formData.append("patient_id", patientData);

                        // Append health matrix fields individually
                        const health = patientDetails?.health_matrix ?? detailsData?.health_matrix ?? {};
                        formData.append("height", health.height || "");
                        formData.append("weight", health.weight || "");
                        formData.append("blood_pressure", health.blood_pressure || "");
                        formData.append("fasting_sugar_level", health.fasting_sugar_level || "");
                        formData.append("postprandial_sugar", health.postprandial_sugar || "");
                        formData.append("hba1c_sugar", health.hba1c_sugar || "");
                        formData.append("sugar_type", health.sugar_type || "");
                        formData.append("pulse_rate", health.pulse_rate || "");
                        formData.append("sleep_pattern", health.sleep_pattern || "");
                        formData.append("digestion", health.digestion || "");
                        formData.append("urine_frequency", health.urine_frequency || "");

                        // Append other patient details
                        formData.append("name", patientDetails.name || "");
                        formData.append("gender", patientDetails.gender || "");
                        formData.append("address", patientDetails.address || "");
                        formData.append("bmi", values.bmi || "");
                        formData.append("bmr", values.bmr || "");

                        // Append form values (arrays stringified)
                        formData.append("medical_condition", JSON.stringify(values.medical_condition ?? []));
                        formData.append("allergies", JSON.stringify(values.allergies ?? []));
                        formData.append("meal_times", JSON.stringify(values.meal_times ?? []));
                        formData.append("cuisine_preference", JSON.stringify(values.cuisine_preference ?? []));
                        formData.append("carving_foods", JSON.stringify(values.carving_foods ?? []));
                        formData.append("health_fitness_goals", JSON.stringify(values.health_fitness_goals ?? []));

                        // Append form values (strings)
                        formData.append("activity_level", values.activity_level || "");
                        formData.append("sleep_quality", values.sleep_quality || "");
                        formData.append("drinking_habits", values.drinking_habits || "");
                        formData.append("smoking_habits", values.smoking_habits || "");
                        formData.append("diet_type", values.diet_type || "");
                        formData.append("other_medical_condition", values.other_medical_condition);
                        formData.append("other_allergies", values.other_allergies);
                        formData.append("tdee", values.tdee);
                        dietChartGenerate(formData)
                            .then((genRes) => {
                                setAddSubmissionLoader(false);
                                if (genRes.success) {
                                    Swal.fire({
                                        icon: "success",
                                        text: "Diet chart generated successfully!",
                                        ...SWAL_SETTINGS,
                                    });
                                    navigate(`/doctor/settings/patient/1`)
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        text: genRes.message || "Failed to generate diet chart",
                                        ...SWAL_SETTINGS,
                                    });
                                }
                            })
                            .catch((err) => {
                                console.error("Error generating diet chart:", err);
                                Swal.fire({
                                    icon: "error",
                                    text: "An error occurred while generating the diet chart.",
                                    ...SWAL_SETTINGS,
                                });
                            });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                })
                .catch((error) => {
                    setAddSubmissionLoader(false);
                    console.error("Error updating profile", error);
                });
            console.log(values);
        },
    });



    const medicalConditionData = MEDICAL_CONDITIONS.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const allergiesData = ALLERGIES.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const mealTimesData = MEAL_TIMES.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const cuisinePreferenceData = CUISINE_PREFERENCE.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const carvingFoodsData = CRAVING_FOODS.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const healthFitnessGoalData = HEALTH_FITNESS_GOALS.map((item) => ({
        label: capitalizeFirstLetter(item?.label),
        value: item?.value,
    }));

    const getTimeFromTimePicker = (e) => {
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(':');
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || '00';
            return `${hours}:${minutes}:${seconds}`
        }
        return ''
    };

    const handleWakeUpTimeChange = (e) => {
        addForm.setFieldTouched('wake_up_time', true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(':');
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || '00';
            addForm.setFieldValue('wake_up_time', `${hours}:${minutes}:${seconds}`);
        }
    };

    const handleSleepTimeChange = (e) => {
        addForm.setFieldTouched('sleep_time', true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(':');
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || '00';
            addForm.setFieldValue('sleep_time', `${hours}:${minutes}:${seconds}`);
        }
    };

    const getDateWithTime = (timeValue) => {
        if (!timeValue) return null;
        const [hours, minutes, seconds] = timeValue.split(':');
        const date = new Date();
        date.setHours(hours, minutes, seconds || '00');
        return date;
    };


    useEffect(() => {
        const selectedActivity = ACTIVITY_LEVEL.find(item => item.value === addForm.values.activity_level);
        const bmr = detailsData?.bmr ?? "";
        if (selectedActivity && bmr) {
            const tdee = Math.round(bmr * selectedActivity.multiplier);
            console.log("tdee", tdee)
            addForm.setFieldValue("tdee", tdee);
        } else {
            addForm.setFieldValue("tdee", "");
        }
    }, [addForm.values.activity_level, detailsData?.bmr]);


    // useEffect(() => {
    //     const formData = new FormData()
    //     formData.append("patient_id", patientData)
    //     dietChartHistory(formData)
    //         .then((response) => {
    //             setDetailsData(response?.data);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // }, [])


    return (
        <main id="main-content">
            <div className="inner-container">
                <section className="card p-4 mb-4 mt-4">
                    <form onSubmit={addForm.handleSubmit}>
                        <div className="row">
                            {/* Medical Conditions */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Medical Conditions")}<span className="text-danger">*</span></label>
                                <TagPicker
                                    data={medicalConditionData}
                                    value={addForm.values.medical_condition}
                                    onChange={(e) => addForm.setFieldValue("medical_condition", e)}
                                    className="form-control-tag-picker cp"
                                    cleanable={false}
                                />
                                {addForm.touched.medical_condition && addForm.errors.medical_condition && (
                                    <div className="text-danger">{t(addForm.errors.medical_condition)}</div>
                                )}
                                {/* Conditionally show input if 'other' is selected */}
                                {addForm.values.medical_condition?.includes("other") && (
                                    <input
                                        type="text"
                                        className="form-control mt-2"
                                        placeholder={t("Please specify other condition")}
                                        value={addForm.values.other_medical_condition}
                                        onChange={(e) => addForm.setFieldValue("other_medical_condition", e.target.value)}
                                    />
                                )}

                                {/* Optional: Show error for other input if needed */}
                                {addForm.touched.other_medical_condition && addForm.errors.other_medical_condition && (
                                    <div className="text-danger">{t(addForm.errors.other_medical_condition)}</div>
                                )}
                            </div>

                            {/* Allergies */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Allergies")}<span className="text-danger">*</span></label>
                                <TagPicker
                                    data={allergiesData}
                                    value={addForm.values.allergies}
                                    onChange={(e) => addForm.setFieldValue("allergies", e)}
                                    className="form-control-tag-picker cp"
                                    cleanable={false}
                                />
                                {addForm.touched.allergies && addForm.errors.allergies && (
                                    <div className="text-danger">{t(addForm.errors.allergies)}</div>
                                )}
                                {/* Conditionally show input if 'other' is selected */}
                                {addForm.values.allergies?.includes("other") && (
                                    <input
                                        type="text"
                                        className="form-control mt-2"
                                        placeholder={t("Please specify other condition")}
                                        value={addForm.values.other_allergies}
                                        onChange={(e) => addForm.setFieldValue("other_allergies", e.target.value)}
                                    />
                                )}

                                {/* Optional: Show error for other input if needed */}
                                {addForm.touched.other_allergies && addForm.errors.other_allergies && (
                                    <div className="text-danger">{t(addForm.errors.other_allergies)}</div>
                                )}
                            </div>

                            {/* Meal Times */}
                            {/* <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Meal Times")}<span className="text-danger">*</span></label>
                                <TagPicker
                                    data={mealTimesData}
                                    value={addForm.values.meal_times}
                                    onChange={(e) => addForm.setFieldValue("meal_times", e)}
                                    className="form-control-tag-picker cp"
                                    cleanable={false}
                                />
                                {addForm.touched.meal_times && addForm.errors.meal_times && (
                                    <div className="text-danger">{t(addForm.errors.meal_times)}</div>
                                )}
                            </div> */}
                            <div className="col-md-12 mb-3 form-box">
                                <label className="form-label">{t("Meal Times")}<span className="text-danger">*</span></label>

                                {mealTimesData.map((meal, index) => {
                                    const isSelected = addForm.values.meal_times.some(m => m.name === meal.value);
                                    return (
                                        <div key={meal.value} className="d-flex align-items-center mb-3 justify-content-between" style={{width : '30%', height: '31px'}}>
                                            <div>
                                                <input
                                                id = {index}
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked={isSelected}
                                                onChange={(e) => {
                                                    const updatedMeals = e.target.checked
                                                        ? [...addForm.values.meal_times, { name: meal.value, time: "" }]
                                                        : addForm.values.meal_times.filter(m => m.name !== meal.value);
                                                    addForm.setFieldValue("meal_times", updatedMeals);
                                                }}
                                                />
                                                <label className="me-3" for={index}>{meal.label}</label>
                                            </div>
                                            {isSelected && (
                                                //  <DatePicker
                                                //     classPrefix="restaurant"
                                                //     placement="autoVertical"
                                                //     format="HH:mm"
                                                //     cleanable={false}
                                                //     editable={true}
                                                //     name="wake_up_time"
                                                //     onChange={(e) => {
                                                //         const timeSelected = getTimeFromTimePicker(e);
                                                //         const updatedMeals = addForm.values.meal_times.map(m =>
                                                //             m.name === meal.value ? { ...m, time: timeSelected } : m
                                                //         );
                                                //         addForm.setFieldValue("meal_times", updatedMeals);
                                                //     }}
                                                //     value={getDateWithTime(addForm.values.meal_times.find(m => m.name === meal.value)?.time || "")}
                                                //     onBlur={addForm.handleBlur}
                                                //     hideMinutes={(minute) => minute % 15 !== 0}
                                                // />
                                                <SelectPicker
                                                    data={NOTIFICATION_INTERVAL}
                                                    className="form-control-tag-picker-single-time"
                                                    onChange={(value) => {
                                                        // handle selected single value
                                                        // const timeSelected = getTimeFromTimePicker(value);
                                                        const updatedMeals = addForm.values.meal_times.map(m =>
                                                            m.name === meal.value ? { ...m, time: value } : m
                                                        );
                                                        addForm.setFieldValue("meal_times", updatedMeals);
                                                    }}
                                                    value={ addForm.values.meal_times.find(m => m.name === meal.value)?.time || ""}
                                                    cleanable={false}
                                                    placeholder="Select time"
                                                />
                                            )}
                                        </div>
                                    );
                                })}

                                {addForm.touched.meal_times && addForm.errors.meal_times && (
                                    <div className="text-danger">{t(addForm.errors.meal_times)}</div>
                                )}
                            </div>


                            {/* Activity Level */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Activity Level")}<span className="text-danger">*</span></label>
                                <select className="form-control cp" name='activity_level' value={addForm.values.activity_level} onChange={addForm.handleChange}>
                                    <option value="">{t("Select")}</option>
                                    {ACTIVITY_LEVEL.map((item, index) => (
                                        <option key={index} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                {addForm.touched.activity_level && addForm.errors.activity_level && (
                                    <div className="text-danger">{t(addForm.errors.activity_level)}</div>
                                )}
                            </div>

                            {/* Sleep Quality */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Sleep Quality")}<span className="text-danger">*</span></label>
                                <select className="form-control cp" name='sleep_quality' value={addForm.values.sleep_quality} onChange={addForm.handleChange}>
                                    <option value="">{t("Select")}</option>
                                    {SLEEP_QUALITY.map((item, index) => (
                                        <option key={index} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                {addForm.touched.sleep_quality && addForm.errors.sleep_quality && (
                                    <div className="text-danger">{t(addForm.errors.sleep_quality)}</div>
                                )}
                            </div>

                            {/* Drinking Habits */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Drinking Habits")}<span className="text-danger">*</span></label>
                                <select className="form-control cp" name='drinking_habits' value={addForm.values.drinking_habits} onChange={addForm.handleChange}>
                                    <option value="">{t("Select")}</option>
                                    {DRINKING_HABITS.map((item, index) => (
                                        <option key={index} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                {addForm.touched.drinking_habits && addForm.errors.drinking_habits && (
                                    <div className="text-danger">{t(addForm.errors.drinking_habits)}</div>
                                )}
                            </div>

                            {/* Smoking Habits */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Smoking Habits")}<span className="text-danger">*</span></label>
                                <select className="form-control cp" name='smoking_habits' value={addForm.values.smoking_habits} onChange={addForm.handleChange}>
                                    <option value="">{t("Select")}</option>
                                    {SMOKING_HABITS.map((item, index) => (
                                        <option key={index} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                {addForm.touched.smoking_habits && addForm.errors.smoking_habits && (
                                    <div className="text-danger">{t(addForm.errors.smoking_habits)}</div>
                                )}
                            </div>

                            {/* Diet Type */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Diet Type")}<span className="text-danger">*</span></label>
                                <select className="form-control cp" name='diet_type' value={addForm.values.diet_type} onChange={addForm.handleChange}>
                                    <option value="">{t("Select")}</option>
                                    {DIET_TYPE.map((item, index) => (
                                        <option key={index} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                {addForm.touched.diet_type && addForm.errors.diet_type && (
                                    <div className="text-danger">{t(addForm.errors.diet_type)}</div>
                                )}
                            </div>

                            {/* Cuisine Preference */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Cuisine Preference")}<span className="text-danger">*</span></label>
                                <TagPicker
                                    data={cuisinePreferenceData}
                                    value={addForm.values.cuisine_preference}
                                    onChange={(e) => addForm.setFieldValue("cuisine_preference", e)}
                                    className="form-control-tag-picker cp"
                                    cleanable={false}
                                />
                                {addForm.touched.cuisine_preference && addForm.errors.cuisine_preference && (
                                    <div className="text-danger">{t(addForm.errors.cuisine_preference)}</div>
                                )}
                            </div>

                            {/* Craving Foods */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Craving Foods")}<span className="text-danger">*</span></label>
                                <TagPicker
                                    data={carvingFoodsData}
                                    value={addForm.values.carving_foods}
                                    onChange={(e) => addForm.setFieldValue("carving_foods", e)}
                                    className="form-control-tag-picker cp"
                                    cleanable={false}
                                />
                                {addForm.touched.carving_foods && addForm.errors.carving_foods && (
                                    <div className="text-danger">{t(addForm.errors.carving_foods)}</div>
                                )}
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Health & Fitness Goals")}<span className="text-danger">*</span></label>
                                <TagPicker
                                    data={healthFitnessGoalData}
                                    value={addForm.values.health_fitness_goals}
                                    onChange={(e) => addForm.setFieldValue("health_fitness_goals", e)}
                                    className="form-control-tag-picker cp"
                                    cleanable={false}
                                />
                                {addForm.touched.health_fitness_goals && addForm.errors.health_fitness_goals && (
                                    <div className="text-danger">{t(addForm.errors.health_fitness_goals)}</div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">
                                    Wake-up Time <span>*</span>
                                </label>
                                <div className="mb-3">
                                    <DatePicker
                                        classPrefix="restaurant"
                                        placement="autoVertical"
                                        format="HH:mm"
                                        cleanable={false}
                                        editable={true}
                                        name="wake_up_time"
                                        onChange={handleWakeUpTimeChange}
                                        value={getDateWithTime(addForm.values.wake_up_time)}
                                        onBlur={addForm.handleBlur}
                                        hideMinutes={(minute) => minute % 15 !== 0}
                                    />
                                    {addForm.touched.wake_up_time && addForm.errors.wake_up_time && (
                                        <div className="text-danger">{t(addForm.errors.wake_up_time)}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">
                                    Sleep Time <span>*</span>
                                </label>
                                <div className="mb-3">
                                    <DatePicker
                                        classPrefix="restaurant"
                                        placement="autoVertical"
                                        format="HH:mm"
                                        cleanable={false}
                                        editable={true}
                                        name="sleep_time"
                                        onChange={handleSleepTimeChange}
                                        value={getDateWithTime(addForm.values.sleep_time)}
                                        onBlur={addForm.handleBlur}
                                        hideMinutes={(minute) => minute % 15 !== 0}
                                    />
                                    {addForm.touched.sleep_time && addForm.errors.sleep_time && (
                                        <div className="text-danger">{t(addForm.errors.sleep_time)}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("BMI(Body Mass Index)")} <span>*</span></label>
                                <input
                                    className="form-control"
                                    type="number"
                                    onChange={addForm.handleChange}
                                    value={(addForm.values.bmi)}
                                    onBlur={addForm.handleBlur}
                                    disabled
                                />
                                {addForm.touched.bmi && addForm.errors.bmi && (
                                    <div className="text-danger">{t(addForm.errors.bmi)}</div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("BMR(Basal Metabolic Rate)")} <span>*</span></label>
                                <input
                                    className="form-control"
                                    type="number"
                                    onChange={addForm.handleChange}
                                    value={(addForm.values.bmr)}
                                    onBlur={addForm.handleBlur}
                                    disabled
                                />
                                {addForm.touched.bmr && addForm.errors.bmr && (
                                    <div className="text-danger">{t(addForm.errors.bmr)}</div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("TDEE(Total Daily Energy Expenditure)")}</label>
                                <input
                                    className="form-control"
                                    type="number"
                                    onChange={addForm.handleChange}
                                    value={(addForm.values.tdee)}
                                    onBlur={addForm.handleBlur}
                                    disabled
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">{t("Age")}<span>*</span></label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder={t("Enter age")}
                                    name="age"
                                    onChange={addForm.handleChange}
                                    value={addForm.values.age}
                                    onBlur={addForm.handleBlur}
                                    disabled
                                />
                                {addForm.touched.age && addForm.errors.age && (
                                    <div className="text-danger">{t(addForm.errors.age)}</div>
                                )}
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="mt-4">
                            <button type="submit" className={`btn btn-primary ${addSubmissionLoader ? " btn-loader" : ""}`}>
                                {t("Submit")}
                            </button>
                        </div>
                    </form>
                </section>

            </div>
        </main>
    );
}
